class SearchEyesIcon extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    document.addEventListener('mousemove', this.handleMouseMove.bind(this))
  }

  handleMouseMove (event) {
    const rect = this.getBoundingClientRect()
    const mouseX = event.clientX - rect.left // Mouse X relative to the SVG
    const mouseY = event.clientY - rect.top // Mouse Y relative to the SVG

    // Calculate the new positions for the pupils
    const leftPupilX = 7.5 // Center X of left pupil
    const leftPupilY = 14.7637 // Center Y of left pupil
    const rightPupilX = 23.5 // Center X of right pupil
    const rightPupilY = 14.7637 // Center Y of right pupil

    // Calculate the distance from the center to the mouse
    const dxLeft = mouseX - leftPupilX
    const dyLeft = mouseY - leftPupilY
    const distanceLeft = Math.sqrt(dxLeft * dxLeft + dyLeft * dyLeft)

    const dxRight = mouseX - rightPupilX
    const dyRight = mouseY - rightPupilY
    const distanceRight = Math.sqrt(dxRight * dxRight + dyRight * dyRight)

    // Limit the pupils' movement to a radius of 3 pixels
    const maxDistance = 3

    if (distanceLeft < maxDistance) {
      this.leftPupil.setAttribute('cx', leftPupilX + dxLeft)
      this.leftPupil.setAttribute('cy', leftPupilY + dyLeft)
    } else {
      this.leftPupil.setAttribute(
        'cx',
        leftPupilX + (dxLeft / distanceLeft) * maxDistance,
      )
      this.leftPupil.setAttribute(
        'cy',
        leftPupilY + (dyLeft / distanceLeft) * maxDistance,
      )
    }

    if (distanceRight < maxDistance) {
      this.rightPupil.setAttribute('cx', rightPupilX + dxRight)
      this.rightPupil.setAttribute('cy', rightPupilY + dyRight)
    } else {
      this.rightPupil.setAttribute(
        'cx',
        rightPupilX + (dxRight / distanceRight) * maxDistance,
      )
      this.rightPupil.setAttribute(
        'cy',
        rightPupilY + (dyRight / distanceRight) * maxDistance,
      )
    }
  }

  get leftPupil () {
    return this.querySelectorAll('circle')[0]
  }

  get rightPupil () {
    return this.querySelectorAll('circle')[1]
  }
}

if (!customElements.get('search-eyes-icon')) {
  customElements.define('search-eyes-icon', SearchEyesIcon)
}
